import { gsap } from "gsap";
    
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initLogoWallCycle() {
    const loopDelay = 1.5;   // Loop Duration
    const duration  = 0.9;   // Animation Duration
  
    document.querySelectorAll('[data-logo-wall-cycle-init]').forEach(root => {
        const list   = root.querySelector('[data-logo-wall-list]');
        const items  = Array.from(list.querySelectorAll('[data-logo-wall-item]'));
  
        const shuffleFront = root.getAttribute('data-logo-wall-shuffle') !== 'false';
        const originalTargets = items
            .map(item => item.querySelector('[data-logo-wall-target]'))
            .filter(Boolean);
  
        let visibleItems   = [];
        let visibleCount   = 0;
        let pool           = [];
        let pattern        = [];
        let patternIndex   = 0;
        let tl;
        let currentlyVisibleLogos = new Set(); // Track currently visible logos
  
        function isVisible(el) {
            return window.getComputedStyle(el).display !== 'none';
        }
  
        function shuffleArray(arr) {
            const a = arr.slice();
            for (let i = a.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [a[i], a[j]] = [a[j], a[i]];
            }
            return a;
        }
  
        function getLogoSource(imgElement) {
            return imgElement.src;
        }
  
        function setup() {
            if (tl) {
                tl.kill();
            }
            visibleItems = items.filter(isVisible);
            visibleCount = visibleItems.length;
  
            pattern = shuffleArray(
                Array.from({ length: visibleCount }, (_, i) => i)
            );
            patternIndex = 0;
  
            // Clear currently visible logos tracking
            currentlyVisibleLogos.clear();
  
            // remove all injected targets
            items.forEach(item => {
                item.querySelectorAll('[data-logo-wall-target]').forEach(old => old.remove());
            });
  
            pool = originalTargets.map(n => n.cloneNode(true));
  
            let front, rest;
            if (shuffleFront) {
                const shuffledAll = shuffleArray(pool);
                front = shuffledAll.slice(0, visibleCount);
                rest  = shuffleArray(shuffledAll.slice(visibleCount));
            } else {
                front = pool.slice(0, visibleCount);
                rest  = shuffleArray(pool.slice(visibleCount));
            }
            pool = front.concat(rest);
  
            for (let i = 0; i < visibleCount; i++) {
                const parent =
                    visibleItems[i].querySelector('[data-logo-wall-target-parent]') ||
                    visibleItems[i];
                const logoToShow = pool.shift();
                parent.appendChild(logoToShow);
                
                // Track this logo as currently visible
                const imgElement = logoToShow.querySelector('img');
                if (imgElement) {
                    currentlyVisibleLogos.add(getLogoSource(imgElement));
                }
            }
  
            tl = gsap.timeline({ repeat: -1, repeatDelay: loopDelay });
            tl.call(swapNext);
            tl.play();
        }
  
        function swapNext() {
            const nowCount = items.filter(isVisible).length;
            if (nowCount !== visibleCount) {
                setup();
                return;
            }
            if (!pool.length) return;
  
            const idx = pattern[patternIndex % visibleCount];
            patternIndex++;
  
            const container = visibleItems[idx];
            const parent =
                container.querySelector('[data-logo-wall-target-parent]') ||
                container.querySelector('*:has(> [data-logo-wall-target])') ||
                container;
            const existing = parent.querySelectorAll('[data-logo-wall-target]');
            if (existing.length > 1) return;
  
            const current  = parent.querySelector('[data-logo-wall-target]');
            const incoming = pool.shift();
  
            // Find a logo that isn't currently visible
            let logoToShow = incoming;
            let attempts = 0;
            const maxAttempts = pool.length;
            
            while (attempts < maxAttempts) {
                const imgElement = logoToShow.querySelector('img');
                if (imgElement && !currentlyVisibleLogos.has(getLogoSource(imgElement))) {
                    break; // Found a logo that isn't currently visible
                }
                
                // Put this logo back in the pool and try another
                pool.push(logoToShow);
                logoToShow = pool.shift();
                attempts++;
            }
            
            // If we couldn't find a unique logo, reset the pool and try again
            if (attempts >= maxAttempts) {
                // Reset pool with all original logos
                pool = originalTargets.map(n => n.cloneNode(true));
                logoToShow = pool.shift();
            }
  
            gsap.set(logoToShow, { yPercent: 50, autoAlpha: 0 });
            parent.appendChild(logoToShow);
            
            // Track the new logo as currently visible
            const imgElement = logoToShow.querySelector('img');
            if (imgElement) {
                currentlyVisibleLogos.add(getLogoSource(imgElement));
            }
  
            if (current) {
                // Remove the old logo from tracking
                const oldImgElement = current.querySelector('img');
                if (oldImgElement) {
                    currentlyVisibleLogos.delete(getLogoSource(oldImgElement));
                }
                
                gsap.to(current, {
                    yPercent: -50,
                    autoAlpha: 0,
                    duration,
                    ease: "expo.inOut",
                    onComplete: () => {
                        current.remove();
                        pool.push(current);
                    }
                });
            }
  
            gsap.to(logoToShow, {
                yPercent: 0,
                autoAlpha: 1,
                duration,
                delay: 0.1,
                ease: "expo.inOut"
            });
        }
  
        setup();
  
        ScrollTrigger.create({
            trigger: root,
            start: 'top bottom',
            end: 'bottom top',
            onEnter:     () => tl.play(),
            onLeave:     () => tl.pause(),
            onEnterBack: () => tl.play(),
            onLeaveBack: () => tl.pause()
        });
  
        document.addEventListener('visibilitychange', () =>
            document.hidden ? tl.pause() : tl.play()
        );
    });
}
  
// Initialize Logo Wall Cycle
document.addEventListener('DOMContentLoaded', () => {
    initLogoWallCycle();
});